import {
    GoogleLoginProvider,
    FacebookLoginProvider,
    AuthServiceConfig as SocialAuthServiceConfig,
} from 'angularx-social-login';

import { ISocialLoginConfig } from '../interfaces';

export const ApiKeyProvider = (config: ISocialLoginConfig) => () => new SocialAuthServiceConfig([
    {
        id: GoogleLoginProvider.PROVIDER_ID,
        provider: new GoogleLoginProvider(config.googleApiKey),
    },
    {
        id: FacebookLoginProvider.PROVIDER_ID,
        provider: new FacebookLoginProvider(config.facebookApiKey),
    },
]);
